import { SettingsOutletLayout } from "~/providers/components/providerSettings/SettingsOutletLayout";
import { ConsultationRequestLinks } from "~/providers/components/tools/consultationRequestLink";

export const ConsultationLinksScreen = () => {
  return (
    <SettingsOutletLayout>
      <ConsultationRequestLinks />
    </SettingsOutletLayout>
  );
};
